import React, { useMemo } from "react";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";

import ActionsDropdown from "../../../../../components/Dropdown/ActionsDropdown";
import { DropdownAction } from "../../../../../components/Dropdown/types";
import { PaymentRowMenuProps } from "./types";

export const PaymentRowMenu: React.FC<PaymentRowMenuProps> = ({
  payment,
  onEditPayment,
  onDeletePayment,
}) => {
  const actions = useMemo<DropdownAction[]>(
    () => [
      {
        id: "edit",
        label: "Edit",
        icon: <EditIcon fontSize="small" />,
        onClick: () => onEditPayment(payment),
        show: true,
      },
      {
        id: "delete",
        label: "Delete",
        icon: <DeleteIcon fontSize="small" />,
        onClick: () => onDeletePayment(payment),
        variant: "destructive" as const,
        show: true,
      },
    ],
    [payment, onEditPayment, onDeletePayment],
  );

  return (
    <ActionsDropdown
      compact
      dropdownActions={actions}
      testId={`payment-row-menu-${payment.id}`}
    />
  );
};

PaymentRowMenu.displayName = "PaymentRowMenu";
